import React from 'react'
import { Button, Checkbox, DatePicker, Form, Modal, Select, Input } from "antd";
import { useFormUser } from '../../../hooks/fileds/useFormUser';

export const FormUser = ({
    isFormCreate = true,
    loading = false,
    allAreas = [],
    rolUser = [],
    dataForm = {},
    activeModal = () => { },
    closeModal = () => { },
    onFinishForm = () => { },
    updateSelection = () => { }
}) => {

    const { form, passwordIsNecesary, onFinish, onValuesChangeForm, validateRetryPassword } = useFormUser({ dataForm, allAreas, isFormCreate, onFinishForm })


    return (
        <Modal title={`${isFormCreate ? "Crear usuario" : "Editar usuario"}`} width={420} open={activeModal} onCancel={closeModal} footer={[]}>
            <Form
                form={form}
                name="global_state" layout="vertical" className='w-full'
                onValuesChange={onValuesChangeForm}
                onFinish={(event) => {
                    updateSelection()
                    onFinish(event)
                }}
            >
                <div className="">
                    <section className='grid grid-cols-2 gap-x-4'>

                        <Form.Item
                            name="name"
                            label="Nombre"
                            tooltip="Nombre completo"
                            rules={[
                                {
                                    required: true,
                                    message: "Nombre",
                                    whitespace: true,
                                },
                            ]}
                        >
                            <Input placeholder='nombre' />
                        </Form.Item>
                        <Form.Item
                            name="email"
                            label="Correo"
                            rules={[
                                {
                                    type: "email",
                                    message: "¡No es un correo valido!",
                                },
                                {
                                    required: true,
                                    message: "Llenar el correo",
                                },
                            ]}
                        >
                            <Input placeholder='@inmersys.com' />
                        </Form.Item>
                        <Form.Item
                            label="Contraseña"
                            name="password"
                            rules={[
                                {
                                    required: passwordIsNecesary,
                                    message: "Pon tu contraseña",
                                },
                                { min: 8, message: "Contraseña minima de 8" },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            label="Confirma Contraseña"
                            name="retrypassword"
                            rules={[
                                validateRetryPassword
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="rol"
                            label="Rol"
                            rules={[
                                {
                                    required: true,
                                    message: "¡Por favor selecciona el rol!",
                                },
                            ]}
                        >
                            <Select placeholder="seleccionar el rol de acceso">
                                {rolUser.map((rol) => (
                                    <Select.Option key={`${rol}--rol`} value={rol}>
                                        {rol}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="area"
                            label="Area"
                            rules={[
                                {
                                    required: true,
                                    message: "¡Por favor selecciona una área!",
                                },
                            ]}
                        >
                            <Select mode="multiple" placeholder="Agregar areas que pertenece">
                                {allAreas.map((area, index) => (
                                    <Select.Option key={`${index}-areauser`} value={area.name}>
                                        {area.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="position" label="Posición">
                            <Input />
                        </Form.Item>
                    </section>
                    <section className=''>
                        <div className="flex items-center gap-4 overflow-hidden pb-4 ">
                            <div className="flex-grow">
                                <h2 className="text-[12px] truncate font-semibold">Fechas</h2>
                            </div>
                            <div className="flex-grow-0 h-[1px] bg-[#CDCDCD] w-full"></div>
                        </div>
                        <div className='grid grid-cols-2 gap-x-4'>
                            <Form.Item name="startedDate" label="Dia de inicio">
                                <DatePicker />
                            </Form.Item>
                            <Form.Item name="fullTimeDate" label="Fecha horario completo">
                                <DatePicker />
                            </Form.Item>
                        </div>
                    </section>
                    <section className=''>
                        <div className="flex items-center gap-4 overflow-hidden pb-4 ">
                            <div className="flex-grow">
                                <h2 className="text-[12px] truncate font-semibold">Email</h2>
                            </div>
                            <div className="flex-grow-0 h-[1px] bg-[#CDCDCD] w-full"></div>
                        </div>
                        <div className='flex gap-4 h-8'>
                            <label htmlFor="isEmailList" className='pt-1'>¿Recibe correos?</label>
                            <Form.Item name="isEmailList" valuePropName="checked">
                                <Checkbox />
                            </Form.Item>
                        </div>
                    </section>
                </div>
                <div className="flex items-end justify-end">
                    <Form.Item className="mb-0">
                        <Button type="primary" htmlType="submit" loading={loading} className="bg-primaryTwo hover:bg-primaryTwoHover">
                            {isFormCreate ? "Crear usuario" : "Editar"}
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )
}
